import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../utils/firebase";
import {  useNavigate } from 'react-router-dom';
import {
  FaGoogle,
  FaApple,
  FaPhoneAlt,
  FaShieldAlt,
  FaTruck,
  FaUndo,
  FaCheckCircle,
  FaArrowLeft 
} from "react-icons/fa";


import {
  google_login,
  customer_auth
} from "../store/reducers/authReducer";

const CustomerAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader, errorMessage } = useSelector((state) => state.auth);

  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "" });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(customer_auth(form)).then((res) => {
  if (res.payload?.token) {
    navigate("/");
  }
});

  };

  const handleGoogleLogin = async () => {
    try {
          const result = await signInWithPopup(auth, googleProvider);
          const user = result.user;
    
          // 🔹 Dispatch to backend via Redux
          dispatch(google_login({
            name: user.displayName,
            email: user.email,
            photo: user.photoURL
          })).then((res) => {
            if (res.payload?.token) {
              navigate('/'); // redirect after successful login
            }
          });
        } catch (error) {
          console.error("Google Login Error:", error);
        }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-6">
      <div className="bg-white w-full max-w-6xl rounded-lg shadow-md relative p-8 md:p-5">
        <button
  onClick={() => navigate("/")}
  className="absolute top-6 left-6 md:static md:mb-4 flex items-center gap-2 text-gray-600 hover:text-orange-600 font-medium transition"
>
  <FaArrowLeft className="text-sm" />
  Back to Home
</button>

        

        {/* Header */}
        <h2 className="text-center text-2xl font-semibold">Sign in / Register</h2>
        <p className="text-center text-green-600 text-sm flex items-center justify-center gap-2 mt-1">
          <FaShieldAlt /> All data is safeguarded
        </p>

        {/* Benefits Row — SINGLE ROW */}
        <div className="mt-6 bg-green-50 border border-green-100 rounded-md px-6 py-4 flex justify-between items-center text-sm md:grid md:grid-cols-2 md:gap-4 md:px-4 xs:grid-cols-1">
          <Benefit icon={<FaCheckCircle />} title="Price adjustment" desc="Within 30 days" />
          <Divider />
          <Benefit icon={<FaTruck />} title="Free shipping" desc="Excludes local items" />
          <Divider />
          <Benefit icon={<FaUndo />} title="Free returns" desc="Up to 90 days" />
          <Divider />
          <Benefit icon={<FaShieldAlt />} title="Delivery guarantee" desc="Refund for any issue" />
        </div>

        {/* MAIN CONTENT */}
        <div className="mt-10 grid grid-cols-2 gap-10 items-start md:grid-cols-1 md:gap-6 md:mt-6">
          
          {/* LEFT SIDE */}
          <div>
            <form onSubmit={handleSubmit}>
              <label className="font-semibold block mb-2">
                Please enter your email address
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-md px-4 py-3 mb-4 focus:ring-2 focus:ring-orange-400 outline-none"
              />

              <input
                type="password"
                name="password"
                placeholder="Enter your password"
                value={form.password}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-md px-4 py-3 mb-4 focus:ring-2 focus:ring-orange-400 outline-none"
              />

              {errorMessage && (
                <p className="text-red-500 text-sm mb-3">{errorMessage}</p>
              )}

              <button
                disabled={loader}
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-full transition"
              >
                {loader
                  ? "Please wait..."
                  : mode === "login"
                  ? "Continue"
                  : "Register"}
              </button>
            </form>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex flex-col gap-4">
            <SocialButton icon={<FaGoogle />} text="Continue with Google" onClick={handleGoogleLogin} />

            {/* <SocialButton icon={<FaApple />} text="Continue with Apple" /> */}
            <SocialButton icon={<FaPhoneAlt />} text="Continue with phone number" />

            <p className="text-sm text-gray-600 text-center mt-2 cursor-pointer hover:underline">
              Trouble signing in?
            </p>
          </div>
        </div >

        {/* Footer */}
        <p className="text-center text-xs text-gray-500 mt-8">
          By continuing, you agree to our{" "}
          <span className="text-blue-600 hover:underline cursor-pointer">Terms of Use</span>{" "}
          and{" "}
          <span className="text-blue-600 hover:underline cursor-pointer">Privacy Policy</span>.
        </p>
      </div>
    </div>
  );
};

/* Reusable Components */
const Benefit = ({ icon, title, desc }) => (
  <div className="flex items-center gap-3">
    <div className="text-green-600 text-lg">{icon}</div>
    <div>
      <p className="font-semibold">{title}</p>
      <p className="text-gray-600 text-xs">{desc}</p>
    </div>
  </div>
);

const Divider = () => <div className="h-10 w-px bg-green-200 mx-4 md:hidden" />;

const SocialButton = ({ icon, text, onClick }) => (
  <button
    onClick={onClick}
    className="border rounded-full py-3 px-4 flex items-center justify-center gap-3 hover:bg-gray-50 transition"
  >
    {icon} {text}
  </button>
);

export default CustomerAuth;
